import styled from 'vue-styled-components';

export const WrapperImage = styled.div`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  bottom: 0;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
`;

export const WrapperPattern = styled.div`
  bottom: 0;
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
`;
